// extracted by mini-css-extract-plugin
module.exports = {"aiHeader":"style_aiHeader__1lez9","summ":"style_summ__TzsqO","textback":"style_textback__2QocV"};